<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#main)
    v-expansion-panels
      v-expansion-panel(
        v-for="(items, categoryTitle) in groups",
        :key="categoryTitle"
      )
        v-expansion-panel-header {{ categoryTitle }}
        v-expansion-panel-content
          a.d-block.pb-2.text-decoration-none(
            v-for="({ title, link }, i) in items",
            :key="i",
            :href="link",
            target="_blank"
          )
            v-icon(small, left) fas fa-globe
            span {{ title }}
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage.vue";
import CommunicationsWidget from "@/components/widgets/Communications";
import { arrayGroupBy } from "@/components/utils";

const _config = {
  mod: "usefulLinks",
  title: "Links Úteis",
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
  }),
  computed: {
    groups() {
      return arrayGroupBy(
        this.$rest(_config.mod).list.map(({ title, link, category_title }) => ({
          title,
          link,
          category_title,
        })),
        "category_title"
      );
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get({ keepCache: true })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
  },
};
</script>
